import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalContainer from './ModalContainer';
import classes from './JackpotGameModal.module.scss';
import bannerImg from '../../../../shared/assets/images/jackpot/jp-game-banner.png';
import { SiteContext } from '@homeplay/app';
import { useContext } from 'react';

const JackpotGameModal = () => {
  const { siteName } = useContext(SiteContext);
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleOk = () => {
    //NOTE: Do not clear wonNotifications! State should be kept for the homepage
    // Player MUST go to the homepage to view the jackpot (as in hpui)
    // Use React Router instead of window.location.href to preserve Redux state
    navigate(`/${siteName}`);
  };

  const handleImageError = () => {
    console.error('Failed to load jackpot banner image');
    setImageError(true);
  };

  return (
    <ModalContainer>
      <div className={classes.Root}>
        <button className={classes.BannerBtn} onClick={handleOk}>
          {!imageError ? (
            <img
              className={classes.Banner}
              src={bannerImg}
              alt="jackpot-banner"
              draggable={false}
              onError={handleImageError}
            />
          ) : (
            <div
              style={{
                width: '100%',
                height: '200px',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '32px',
                color: '#666',
              }}
            >
              Jackpot Banner
            </div>
          )}
        </button>
      </div>
    </ModalContainer>
  );
};

export default React.memo(JackpotGameModal);



